export default __webpack_public_path__ + "static/media/posz.dd976f1f.jpg";